import { emailsConfig } from "./emails"
import { i18nConfig } from "./i18n"
import { linksConfig } from "./links"
import { mainNavConfig } from "./navigation"
import { pricingPlansConfig as pricingConfig } from "./pricing"
import { sidebarConfig } from "./sidebar"
import { siteConfig } from "./site"

export const config = {
  i18n: i18nConfig,
  site: siteConfig,
  links: linksConfig,
  emails: emailsConfig,
  mainNav: mainNavConfig,
  sidebar: sidebarConfig,
  pricing: pricingConfig,
} as const

export type Config = typeof config
